module.exports = __webpack_public_path__ + "static/media/Unfilled Check Mark.e07f5091.svg";